import React from 'react';

import Header from '../../../../../components/checkout/Header';
import CenteredContainer from 'components/CenteredContainer';
import { useViewEvent } from 'features/events/context/ViewEvent';
import { CheckoutSteps } from '../../types';
import EventInfo from '../EventInfo';
import Button from 'components/Button';
import { useCheckout } from '../../context';
import { capitalize } from 'lodash';
import GuestWaiver from './components/GuestWaiver';
import TopBackgroundWrapper from 'components/checkout/TopBackgroundWrapper';
import CheckoutTimer from '../CheckoutTimer';
import { useTranslation } from 'react-i18next';

const WaiverStep = () => {
  const { t } = useTranslation(['checkout']);
  const { event } = useViewEvent();
  const {
    checkoutSession: {
      confirmCheckout,
      isLoadingCheckout,
      checkoutError,
      isCheckoutDisabled
    },
    user,
    waivers,
    onSuccess,
    paymentMethod,
    goToStep
  } = useCheckout();

  const goToSummary = () => {
    waivers.setTotalCheckedWaivers(0);
    goToStep(CheckoutSteps.Summary);
  };

  const onConfirmCheckout = () => {
    if (event.prePurchaseFormId) {
      goToStep(CheckoutSteps.PrePurchaseQuestions);
    } else {
      confirmCheckout({ allWaiversAccepted: waivers.allWaiversAccepted }).then(
        () => {
          onSuccess();
          goToStep(CheckoutSteps.Success);
        }
      );
    }
  };

  let buttonText = null;
  if (event.prePurchaseFormId) {
    buttonText = t('checkout:continueToPrePurchaseQuestions');
  } else if (paymentMethod.selectedBuyNowPayLater.value) {
    buttonText = t('checkout:continueTo', {
      paymentMethod: capitalize(paymentMethod.selectedBuyNowPayLater.value)
    });
  } else {
    buttonText = t('checkout:confirmWaiversAndPay', {
      count: waivers.totalCheckedWaivers,
      total: waivers.data.length
    });
  }

  return (
    <>
      <Header
        onBack={goToSummary}
        title={t('checkout:waivers')}
        subtitle={event.title}
        isUserLoggedIn={!!user}
        TimerComponent={CheckoutTimer}
      />
      <TopBackgroundWrapper
        imageUrl={event.photo.url}
        hasTierNav={false}
        isUserLoggedIn={!!user}
        className="md:py-14"
      >
        <EventInfo />
      </TopBackgroundWrapper>
      <CenteredContainer hasPadding={false} wideContent>
        <div className="px-4 gap-5 md:gap-8 flex flex-col pb-10">
          <div className="max-w-[650px] mx-auto flex flex-col gap-5">
            <GuestWaiver
              hasWrapper={false}
              onGoBack={goToSummary}
              waivers={waivers.data}
              setCheckedWaiverCount={waivers.setTotalCheckedWaivers}
              waiverStyle={
                checkoutError?.message ? 'max-h-[75vh] md:max-h-[450px]' : ''
              }
            />
            {checkoutError?.message && (
              <div className="text-error text-center pb-2">
                {checkoutError.message}
              </div>
            )}
            <Button
              variant="primaryDark"
              onClick={onConfirmCheckout}
              size="large"
              loading={isLoadingCheckout}
              className="w-full"
              disabled={!waivers.allWaiversAccepted || isCheckoutDisabled}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </CenteredContainer>
    </>
  );
};

export default WaiverStep;
